import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Tooltip,
  Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import TextInput from 'components/form/input/TextInput';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function ProdutoAccordionList({

  agrupados, // Array de [grupoNome, detalhamentos[]]
  onRemover, // function(detalhamento) para um item
  onRemoverGrupo, // function(grupoNome)
  field,
  permiteEditarDescricao,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return agrupados.map(([grupoNome, detalhamentos]) => (
    <Accordion
      key={grupoNome}
      sx={{
        width: '100%',
        mb: 1,
        '&::before': { display: 'none' }
      }}
      disableGutters
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
        sx={{
          minHeight: 36,
          '& .MuiAccordionSummary-content': {
            margin: 0,
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column', // Agrupa nome e produtos em colunas
            width: '100%',
          },
          px: 1
        }}
      >
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', position: 'relative' }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: 15,
                fontWeight: 500,
                lineHeight: 1.3,
                flex: 1,                
                whiteSpace: 'wrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                pr: 1,
              }}
            >
              {grupoNome}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.5,
                fontSize: 13,
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                width: '100%',
                maxWidth: { xs: '100%', sm: 400 },
              }}
            >
              {(() => {
                const max = 3;
                const nomes = detalhamentos.map((d) =>
                  d.produto.nome + (d.descricaoRodada ? ` (${d.descricaoRodada})` : '')
                );
                if (nomes.length <= max) return nomes.join(', ');
                return `${nomes.slice(0, max).join(', ')}... e +${nomes.length - max}`;
              })()}
            </Typography>
          </Box>
          <Tooltip title={`Remover todos de "${grupoNome}"`}>
            <IconButton
              size="small"
              color="error"
              sx={{ ml: 1, alignSelf: 'center' }}
              onClick={e => {
                e.stopPropagation();
                onRemoverGrupo(grupoNome);
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ py: 0.5, px: 1 }}>
        {detalhamentos.map((detalhamento) => (
          <Box
            key={detalhamento.produto.uid}
            display="flex"
            alignItems="center"
            py={0.5}
            px={0}
            gap={1}
          >
            <IconButton
              onClick={() => onRemover(detalhamento)}
              size="small"
              sx={{ mr: 0.5 }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: permiteEditarDescricao ? 'center' : 'flex-start',
                flexDirection: permiteEditarDescricao ? 'row' : 'column',
                gap: 0.5
              }}
            >
              {permiteEditarDescricao ? (
                <>
                  <Typography sx={{ flex: 1, minWidth: 120 }}>{detalhamento.produto.nome}</Typography>
                  <TextInput
                    name={field + "." + detalhamento.indexList + ".descricaoRodada"}
                    label="DESCRIÇÃO"
                    multiline
                    sx={{ flex: 1 }}
                  />
                </>
              ) : (
                <>
                  <Typography>{detalhamento.produto.nome}</Typography>
                  {!!detalhamento.descricaoRodada && (
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                      {detalhamento.descricaoRodada}
                    </Typography>
                  )}
                </>
              )}
            </Box>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion >
  ));
}